const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.02 8.59C19.62 7.89 20 7 20 6V4c0-2.21-1.79-4-4-4s-4 1.79-4 4v2c0 1 .38 1.89.98 2.59-.38.15-.73.34-1.08.54A3.999 3.999 0 004 10v2c0 1 .38 1.89.98 2.59C2.06 15.79 0 18.65 0 22v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-1.46-.41-2.82-1.1-4H23c.55 0 1-.45 1-1v-1c0-3.35-2.06-6.21-4.98-7.41zM14 4c0-1.1.9-2 2-2s2 .9 2 2v2c0 1.1-.9 2-2 2s-2-.9-2-2zm.15 12.92c.01.01.01.02.02.02l-.02-.02zm-.89-.92a8.007 8.007 0 00-2.24-1.41c.6-.7.98-1.59.98-2.59v-.46A5.98 5.98 0 0116 10c3.31 0 6 2.69 6 6z"
});

const SvgTeamFilled = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTeamFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/team-filled.1003d3f0.svg";
export { ForwardRef as ReactComponent };